import { IUserSettings } from '../interfaces/IUserSettings';

export default class UserSettings implements IUserSettings
{
  userLanguage: string;
}
